import styled from 'styled-components';
import { theme } from './tokens/theme';

const StyledLayoutGrid = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100vh;
`;

const StyledContentArea = styled.div`
  display: flex;
  overflow: hidden;
`;

const StyledOutletWrapper = styled.div`
  position: relative;
  flex: 1;
  overflow: auto;
  background-color: ${theme.light.ui.background.default};
`;

const StyledOutletColumn = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

export { StyledLayoutGrid as LayoutGrid };
export { StyledContentArea as ContentArea };
export { StyledOutletColumn as OutletColumn };
export { StyledOutletWrapper as OutletWrapper };
